const promoColors = {
    primary: '#7633FF',
    primaryB2B: '#0B3176',
    white: '#ffffff',
    whiteRgba48: 'rgba(255, 255, 255, 0.48)',
    baseColor: '#222222',
    purple80: '#925CFF',
    purple40: '#C8ADFF',
    purple20: '#E4D6FF',
    purple5: '#F8F5FF',
    gray100: '#141414',
    gray80: '#4E4E4E',
    gray40: '#A7A7A7',
    gray20: '#D3D3D3',
    gray5: '#F2F1F0',
    sunflower: '#FF9B6A',
    cyan: '#2FB6FF',
    lavender: '#9CA0FF',
    turquoise: '#1CDAC3',
    shadow: 'rgba(104, 104, 104, 0.08)',
    overlay: 'rgba(0, 0, 0, 0.4)',
    error: '#FF6666',
    success: '#67AA66',
    aubergine: '#D4A0FF',
    transparent: 'transparent',

    /* gradients */
    aubergine01: 'linear-gradient(180deg, #7633FF 0%, #AF60E0 95.56%, #D4A0FF 199.14%)',
    aubergine02: 'linear-gradient(180deg, #7633FF -49.79%, #AF60E0 51.08%, #D6A3FF 152.49%)',
    aubergine03: 'linear-gradient(180deg, #7633FF -102.71%, #AF60E0 -5.26%, #DAABFF 100.36%)',
    aubergine04: 'linear-gradient(180deg, #7028E4 0%, #9F44FF 100%)',
    aubergine05: 'linear-gradient(180deg, rgba(159, 68, 255, 0.02) 0%, rgba(159, 68, 255, 0.07) 100%)',
    eggshell01: 'linear-gradient(180deg, #F5F5F5 0%, #FBFBFB 100%)',
    eggshell02: 'linear-gradient(180deg, #FBFBFB 0%, #FAFBFA 100%)',
    eggshell03: 'linear-gradient(180deg, #FAFAFA 0%, #FEFEFE 100%)',
    passionFruit01: 'linear-gradient(180deg, #9F44FF -1.03%, #E482C9 100%)',
    passionFruit02: 'linear-gradient(180deg, #C365E2 0%, #E482C9 49.71%, #EF8CA4 100%)',
    passionFruit03: 'linear-gradient(180deg, #E482C9 0%, #FF9B6A 100%)',
    oceanBlue01: 'linear-gradient(180deg, #7F2FFF 0.53%, #4D69FF 100%)',
    oceanBlue02: 'linear-gradient(180deg, #6250FF 0%, #4D69FF 47.01%, #588FF8 100%)',
    oceanBlue03: 'linear-gradient(180deg, #4D69FF 0%, #68C4EE 100%)',
    blueberryBlue01: 'linear-gradient(180deg, #0F3596 -5.71%, #417EC7 100%)',
    blueberryBlue02: 'linear-gradient(180deg, #1F4CA5 0%, #417EC7 48.15%, #7D94EC 100%)',
    blueberryBlue03: 'linear-gradient(180deg, #417EC7 0%, #9CA0FF 100.36%)',
    jade01: 'linear-gradient(180deg, #006B68 0.53%, #1CA69F 100%)',
    jade02: 'linear-gradient(180deg, #11918A 0%, #71CFCE 100%)',
    jade03: 'linear-gradient(180deg, #42B1AC 0%, #4780CA 100%)',
    dailyPay: 'linear-gradient(90deg, #FF4C00 0%, #7F2FFF 100%)',
    jetBlue: 'linear-gradient(90deg, #0002A3 0%, #7F2FFF 100%)',
    jetBlueVertical: 'linear-gradient(180deg, #0103A3 0%, #9E44FE 100%)',

    /* shadow */
    shadowLoose: '0 0 24px 4px rgba(104, 104, 104, 0.08)',
    shadowCollected: '0 0 12px 2px rgba(78, 78, 78, 0.16)',
};

export default promoColors;
